module.exports = __webpack_public_path__ + "static/media/bass-guitar.97866292.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LessonsPage/assets/bass-guitar.png
// module id = 514
// module chunks = 0